import { useEffect, useState } from "react";
import { createServiceOrderEvent, createTechnicalRecord, listServiceOrders, listVehicles } from "../services/api";

const initialMessages = [
  { id: 1, author: "Você", role: "Técnico · PWA Campo", time: "14:39", text: "Check-in realizado. Estou iniciando a análise da câmera da recepção.", mine: true },
  { id: 2, author: "Central WellTech", role: "Central · PWA Global", time: "14:42", text: "Recebido. Verifique também o enlace com o switch CFTV e registre fotos do rack.", mine: false },
  { id: 3, author: "Você", role: "Técnico · PWA Campo", time: "15:04", media: "2 fotos anexadas", text: "Enlace ativo. Identifiquei perda intermitente de alimentação na câmera.", mine: true }
];

const previewOrders = [
  { id: "preview-1", protocol: "ATD-20260809-081510-A7F2", title: "Câmera da recepção sem imagem", description: "Cliente informou que a câmera da recepção perdeu a imagem durante a manhã. O DVR continua ligado e as demais câmeras estão funcionando normalmente.", requester_name: "Mariana · IVO BARBOZA ADVOGADOS", requester_phone: "(11) 99999-0101", service_address: "Av. Paulista, 1000 · São Paulo/SP", classification: "CFTV · Câmera IP", priority: "ALTA", origin_channel: "WhatsApp", created_at: "2026-08-09T08:15:10-03:00", sla_remaining_seconds: 4920 },
  { id: "preview-2", protocol: "ATD-20260809-093245-B4D1", title: "Ponto de rede sem conexão", description: "O computador da sala administrativa não acessa a rede desde o início do expediente. O cabo já foi reconectado pelo usuário.", requester_name: "Cliente corporativo", requester_phone: "Não informado", classification: "Rede local · Cabeamento", priority: "MÉDIA", origin_channel: "PWA Cliente", created_at: "2026-08-09T09:32:45-03:00", sla_remaining_seconds: 10320 },
  { id: "preview-3", protocol: "ATD-20260809-110507-C9E3", title: "Telefone IP não registra", description: "Novo telefone IP apresenta a mensagem não registrado. Solicitação para validar ramal e configuração da central.", requester_name: "Unidade administrativa", requester_phone: "Não informado", classification: "Telefonia IP", priority: "BAIXA", origin_channel: "Central", created_at: "2026-08-09T11:05:07-03:00", sla_remaining_seconds: 18480 }
];

function formatOpenedAt(value) {
  return value ? new Intl.DateTimeFormat("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" }).format(new Date(value)) : "—";
}

function formatSla(seconds) {
  if (seconds == null) return "Não informado";
  if (seconds <= 0) return "SLA vencido";
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  return `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(2, "0")}min`;
}

export function TechnicianFieldWorkspacePage({ user = { full_name: "Carlos Almeida", email: "carlos@welltech.net.br" } }) {
  const [journeyStarted, setJourneyStarted] = useState(false);
  const [journeyNotice, setJourneyNotice] = useState("");
  const [journeyBusy, setJourneyBusy] = useState(false);
  const [vehicles, setVehicles] = useState([]);
  const [journey, setJourney] = useState({ vehicle: "", odometer: "", vehicleOk: false, toolsOk: false, ppeOk: false, locationOk: false });
  const [tab, setTab] = useState("chat");
  const [status, setStatus] = useState("Aguardando localização");
  const [draft, setDraft] = useState("");
  const [messages, setMessages] = useState(initialMessages);
  const [orders, setOrders] = useState([]);
  const [ordersBusy, setOrdersBusy] = useState(false);
  const [ordersNotice, setOrdersNotice] = useState("");
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [travelFormOpen, setTravelFormOpen] = useState(false);
  const [travelOrigin, setTravelOrigin] = useState("");
  const [travelCoordinates, setTravelCoordinates] = useState(null);
  const [travelBusy, setTravelBusy] = useState(false);
  const [travelNotice, setTravelNotice] = useState("");

  useEffect(() => {
    if (import.meta.env.DEV && window.location.pathname.startsWith("/preview/")) return;
    listVehicles().then((result) => setVehicles(result.items ?? [])).catch(() => setVehicles([]));
  }, []);

  useEffect(() => {
    if (!journeyStarted) return;
    const isPreview = import.meta.env.DEV && window.location.pathname.startsWith("/preview/");
    if (isPreview) {
      setOrders(previewOrders);
      return;
    }
    setOrdersBusy(true);
    setOrdersNotice("");
    listServiceOrders()
      .then((result) => setOrders([...(result.items ?? [])].sort((a, b) => new Date(a.created_at) - new Date(b.created_at))))
      .catch((error) => setOrdersNotice(error.message ?? "Não foi possível carregar os chamados atribuídos."))
      .finally(() => setOrdersBusy(false));
  }, [journeyStarted]);

  function send(event) {
    event.preventDefault();
    if (!draft.trim()) return;
    setMessages((items) => [...items, { id: Date.now(), author: "Você", role: "Técnico · PWA Campo", time: "agora", text: draft.trim(), mine: true }]);
    setDraft("");
  }

  function useCurrentLocation() {
    setTravelNotice("");
    const isPreview = import.meta.env.DEV && window.location.pathname.startsWith("/preview/");
    if (isPreview) {
      setTravelOrigin("Base WellTech · localização atual confirmada");
      setTravelCoordinates(null);
      return;
    }
    if (!navigator.geolocation) {
      setTravelNotice("Localização indisponível. Informe o ponto de saída manualmente.");
      return;
    }
    setTravelBusy(true);
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        setTravelOrigin(`Localização atual · ${coords.latitude.toFixed(5)}, ${coords.longitude.toFixed(5)}`);
        setTravelCoordinates({ latitude: coords.latitude, longitude: coords.longitude });
        setTravelBusy(false);
      },
      () => {
        setTravelNotice("Não foi possível obter a localização. Informe onde está manualmente.");
        setTravelBusy(false);
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  }

  async function confirmTravelStart(event) {
    event.preventDefault();
    if (!travelOrigin.trim()) {
      setTravelNotice("Informe de onde está saindo ou use a localização atual.");
      return;
    }
    const isPreview = import.meta.env.DEV && window.location.pathname.startsWith("/preview/");
    setTravelBusy(true);
    setTravelNotice("");
    try {
      if (!isPreview) {
        await createServiceOrderEvent(selectedOrder.id, {
          event_type: "TECHNICIAN_TRAVEL_STARTED",
          actor_type: "technician",
          description: `Técnico iniciou deslocamento. Origem: ${travelOrigin.trim()}`,
          status_after: "IN_PROGRESS"
        });
      }
      setStatus("Em deslocamento");
      setTravelFormOpen(false);
    } catch (error) {
      setTravelNotice(error.message ?? "Não foi possível registrar o deslocamento.");
    } finally {
      setTravelBusy(false);
    }
  }

  function acceptOrder(order) {
    setSelectedOrder(order);
    setStatus("Aguardando localização");
    setTravelOrigin("");
    setTravelCoordinates(null);
    setTravelNotice("Confirme sua localização atual para iniciar o deslocamento.");
    setTravelFormOpen(true);
  }

  async function confirmArrival() {
    if (status !== "Em deslocamento") return;
    const isPreview = import.meta.env.DEV && window.location.pathname.startsWith("/preview/");
    setTravelBusy(true);
    try {
      if (!isPreview) {
        await createServiceOrderEvent(selectedOrder.id, {
          event_type: "TECHNICIAN_ARRIVED",
          actor_type: "technician",
          description: "Técnico confirmou chegada ao local e iniciou o atendimento.",
          status_after: "IN_PROGRESS"
        });
      }
      setStatus("Em atendimento");
    } catch (error) {
      setTravelNotice(error.message ?? "Não foi possível confirmar a chegada.");
    } finally {
      setTravelBusy(false);
    }
  }

  function openRoute() {
    const destination = selectedOrder.service_address;
    if (!destination) return;
    const origin = travelCoordinates
      ? `${travelCoordinates.latitude},${travelCoordinates.longitude}`
      : travelOrigin.trim();
    const query = new URLSearchParams({ api: "1", destination: String(destination), travelmode: "driving" });
    if (origin) query.set("origin", origin);
    window.open(`https://www.google.com/maps/dir/?${query.toString()}`, "_blank", "noopener,noreferrer");
  }

  async function startJourney(event) {
    event.preventDefault();
    const vehicleChecklistPending = Boolean(journey.vehicle) && !journey.vehicleOk;
    if (!journey.locationOk || vehicleChecklistPending || !journey.toolsOk || !journey.ppeOk) {
      setJourneyNotice("Confirme localização e checklist antes de iniciar.");
      return;
    }
    const isPreview = import.meta.env.DEV && window.location.pathname.startsWith("/preview/");
    setJourneyBusy(true); setJourneyNotice("");
    try {
      if (!isPreview) {
        const result = await createTechnicalRecord({
          record_type: "WORK_ACTIVITY", record_date: new Date().toISOString().slice(0, 10),
          technician_name: user.full_name ?? user.email, vehicle_item_id: journey.vehicle || null,
          event_kind: "JOURNEY_START", odometer_km: journey.odometer || null,
          description: "Início da jornada de trabalho", occurred_at: new Date().toISOString(),
          location_snapshot: { authorized: true, source: "pwa_campo" }, evidence: [],
          extracted_data: { checklist: { vehicle_ok: journey.vehicle ? journey.vehicleOk : null, tools_ok: journey.toolsOk, ppe_ok: journey.ppeOk }, availability: "AVAILABLE" }
        });
        localStorage.setItem("well_active_journey", JSON.stringify({ protocol: result.protocol_number, started_at: new Date().toISOString() }));
      }
      setJourneyStarted(true);
    } catch (error) { setJourneyNotice(error.message ?? "Não foi possível iniciar a jornada."); }
    finally { setJourneyBusy(false); }
  }

  return <section className="field-workspace">
    {!journeyStarted ? <section className="journey-start">
      <header><div className="journey-brand">W</div><div><span>WELLTECH CAMPO</span><h1>Início da jornada</h1><p>Bom dia, Carlos. Confirme os dados antes de ficar disponível.</p></div></header>
      <div className="journey-time"><div><span>DATA</span><b>09 de agosto de 2026</b></div><div><span>HORÁRIO</span><b>08:00</b></div><i>Registro automático</i></div>
      <form onSubmit={startJourney}>
        <label>Veículo do dia<select value={journey.vehicle} onChange={(event) => setJourney((current) => ({ ...current, vehicle: event.target.value, odometer: event.target.value ? current.odometer : "", vehicleOk: event.target.value ? current.vehicleOk : false }))}><option value="">Sem veículo / atuação remota</option>{vehicles.map((vehicle) => <option key={vehicle.id} value={vehicle.id}>{vehicle.name}</option>)}{!vehicles.length ? <><option value="11111111-1111-1111-1111-111111111111">Fiat Fiorino · FT-01</option><option value="22222222-2222-2222-2222-222222222222">Saveiro · ST-02</option></> : null}</select></label>
        {journey.vehicle ? <label>Quilometragem inicial<input inputMode="numeric" value={journey.odometer} onChange={(event) => setJourney((current) => ({ ...current, odometer: event.target.value }))} placeholder="Ex.: 48210" /></label> : null}
        <button type="button" className={`journey-location ${journey.locationOk ? "confirmed" : ""}`} onClick={() => setJourney((current) => ({ ...current, locationOk: true }))}><span>◎</span><div><b>{journey.locationOk ? "Localização confirmada" : "Confirmar localização"}</b><small>{journey.locationOk ? "Base WellTech · precisão 12 m" : "Usada durante a jornada conforme autorização"}</small></div></button>
        <fieldset><legend>Checklist de saída</legend>
          {journey.vehicle ? <label><input type="checkbox" checked={journey.vehicleOk} onChange={(event) => setJourney((current) => ({ ...current, vehicleOk: event.target.checked }))}/><span><b>Veículo em condições</b><small>Pneus, iluminação, combustível e avarias</small></span></label> : null}
          <label><input type="checkbox" checked={journey.toolsOk} onChange={(event) => setJourney((current) => ({ ...current, toolsOk: event.target.checked }))}/><span><b>Ferramentas conferidas</b><small>Kit técnico e equipamentos necessários</small></span></label>
          <label><input type="checkbox" checked={journey.ppeOk} onChange={(event) => setJourney((current) => ({ ...current, ppeOk: event.target.checked }))}/><span><b>EPIs conferidos</b><small>Itens adequados às atividades programadas</small></span></label>
        </fieldset>
        {journey.vehicle ? <label className="journey-photo">Foto do hodômetro ou veículo <input type="file" accept="image/*" capture="environment" /></label> : null}
        {journeyNotice ? <p className="journey-notice">{journeyNotice}</p> : null}
        <button type="submit" className="journey-submit" disabled={journeyBusy}>{journeyBusy ? "Registrando jornada…" : "Iniciar jornada e ficar disponível"}</button>
      </form>
      <footer><span>O início será registrado na linha do tempo operacional.</span><b>Sincronização segura</b></footer>
    </section> : null}
    {journeyStarted && !selectedOrder ? <>
    <header className="field-head"><div><span>WELLTECH CAMPO</span><h1>Olá, {user.full_name?.split(" ")[0] ?? "Técnico"}</h1><p>Você está disponível para atendimento</p></div><button type="button">{orders.length} chamados</button></header>
    <section className="field-queue">
      <header><div><span>FILA DE ATENDIMENTO</span><h2>Chamados abertos</h2></div><b>Mais antigos primeiro</b></header>
      {ordersBusy ? <p className="field-queue-notice">Carregando chamados atribuídos…</p> : null}
      {ordersNotice ? <p className="field-queue-notice error">{ordersNotice}</p> : null}
      {!ordersBusy && !ordersNotice && !orders.length ? <p className="field-queue-notice">Nenhum chamado atribuído no momento. Você continuará disponível.</p> : null}
      <div className="field-queue-list">{orders.map((order, index) => <article key={order.id}>
        <div className="field-queue-position">{index + 1}</div>
        <div><small>{order.protocol}</small><h3>{order.title}</h3><p>{order.requester_name || "Cliente não informado"}</p><time>Aberto em {formatOpenedAt(order.created_at)}</time></div>
        <aside><span>{order.priority || "NORMAL"}</span><b>{formatSla(order.sla_remaining_seconds)}</b><button type="button" onClick={() => acceptOrder(order)}>Aceitar chamado</button></aside>
      </article>)}</div>
    </section>
    <nav className="field-bottom"><button className="active">Início</button><button>Chamados</button><button>Conversas</button><button>Registros</button></nav>
    </> : null}
    {journeyStarted && selectedOrder ? <>
    <header className="field-head"><div><span>WELLTECH CAMPO</span><h1>Olá, {user.full_name?.split(" ")[0] ?? "Técnico"}</h1><p>Atendimento selecionado</p></div><button type="button" onClick={() => setSelectedOrder(null)}>Voltar à fila</button></header>
    <article className="field-order-card">
      <div className="field-order-top"><div><small>{selectedOrder.protocol}</small><h2>{selectedOrder.title}</h2><p>{selectedOrder.requester_name || "Cliente não informado"}</p></div><span>{status}</span></div>
      <div className="field-order-details"><div><span>SLA restante</span><b>{formatSla(selectedOrder.sla_remaining_seconds)}</b></div><div><span>Prioridade</span><b>{selectedOrder.priority || "Normal"}</b></div><div><span>Origem</span><b>{selectedOrder.origin_channel || "Central"}</b></div></div>
      <section className="field-opening-info">
        <span>INFORMAÇÕES FORNECIDAS NA ABERTURA</span>
        <p>{selectedOrder.description || "O cliente não informou uma descrição adicional."}</p>
        <dl>
          <div><dt>Solicitante</dt><dd>{selectedOrder.requester_name || "Não informado"}</dd></div>
          <div><dt>Contato</dt><dd>{selectedOrder.requester_phone || "Não informado"}</dd></div>
          <div><dt>Classificação</dt><dd>{selectedOrder.classification || "Não classificado"}</dd></div>
          <div><dt>Abertura</dt><dd>{formatOpenedAt(selectedOrder.created_at)} · {selectedOrder.origin_channel || "Canal não informado"}</dd></div>
        </dl>
      </section>
      <div className="field-address"><span>ENDEREÇO CADASTRADO DO CLIENTE</span><b>{selectedOrder.service_address || "Endereço não informado"}</b><small>{selectedOrder.service_address ? "Destino obtido do cadastro do cliente" : "Cadastre o endereço do cliente antes do deslocamento"}</small><button type="button" onClick={openRoute} disabled={!travelOrigin || !selectedOrder.service_address}>Abrir rota</button></div>
      {status === "Em deslocamento" && travelOrigin ? <div className="field-travel-origin"><span>ORIGEM DO DESLOCAMENTO</span><b>{travelOrigin}</b><small>Registrado na linha do tempo do chamado</small></div> : null}
      {travelFormOpen ? <form className="field-travel-form" onSubmit={confirmTravelStart}>
        <span>DE ONDE VOCÊ ESTÁ SAINDO?</span>
        <input value={travelOrigin} onChange={(event) => { setTravelOrigin(event.target.value); setTravelCoordinates(null); }} placeholder="Ex.: Base WellTech, cliente anterior ou endereço" />
        <button type="button" onClick={useCurrentLocation} disabled={travelBusy}>◎ Usar localização atual</button>
        {travelNotice ? <p>{travelNotice}</p> : null}
        <div><button type="button" onClick={() => setTravelFormOpen(false)}>Cancelar</button><button type="submit" disabled={travelBusy}>{travelBusy ? "Registrando…" : "Confirmar deslocamento"}</button></div>
      </form> : null}
      <div className="field-status-actions field-status-actions-two"><button type="button" onClick={() => { setTravelNotice(""); setTravelFormOpen(true); }}>Atualizar localização</button><button type="button" className="active" disabled={status !== "Em deslocamento" || travelBusy} onClick={confirmArrival}>{travelBusy ? "Registrando…" : "Cheguei e iniciar"}</button></div>
    </article>

    <nav className="field-tabs"><button type="button" className={tab === "chat" ? "active" : ""} onClick={() => setTab("chat")}>Conversa</button><button type="button" className={tab === "details" ? "active" : ""} onClick={() => setTab("details")}>Orientações</button><button type="button" className={tab === "evidence" ? "active" : ""} onClick={() => setTab("evidence")}>Evidências</button></nav>

    {tab === "chat" ? <section className="field-chat">
      <header><div><span>Central WellTech</span><b>Atendimento acompanhado</b></div><i /></header>
      <div className="field-message-list"><span>Hoje · protocolo preservado</span>{messages.map((message) => <article key={message.id} className={message.mine ? "mine" : "theirs"}><div><b>{message.author}</b><small>{message.role}</small></div>{message.media ? <em>▣ {message.media}</em> : null}<p>{message.text}</p><time>{message.time} ✓✓</time></article>)}<span>Mensagens vinculadas à ordem de serviço</span></div>
      <form onSubmit={send}><button type="button" aria-label="Anexar foto">＋</button><textarea rows="1" value={draft} onChange={(event) => setDraft(event.target.value)} placeholder="Responder à Central…"/><button type="submit">Enviar</button></form>
    </section> : null}

    {tab === "details" ? <section className="field-info-card"><span>ORIENTAÇÕES DA CENTRAL</span><h3>Verificar câmera e enlace CFTV</h3><ol><li>Validar alimentação da câmera.</li><li>Testar enlace com o switch CFTV.</li><li>Registrar fotos da câmera e do rack.</li><li>Informar diagnóstico antes de substituir equipamentos.</li></ol></section> : null}
    {tab === "evidence" ? <section className="field-info-card"><span>EVIDÊNCIAS</span><h3>2 fotos adicionadas</h3><div className="field-evidence-grid"><div>Foto da câmera</div><div>Foto do rack</div></div><button type="button" className="field-add-evidence">＋ Adicionar foto ou documento</button></section> : null}

    <button className="field-finish" type="button">Solicitar conclusão do atendimento</button>
    <nav className="field-bottom"><button className="active">Início</button><button>Chamados</button><button>Conversas</button><button>Registros</button></nav>
    </> : null}
  </section>;
}
